import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from "react";
import DatePicker from "../DatePicker";
var DatePickerField = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePickerField, _React$Component);
  var _super = _createSuper(DatePickerField);
  function DatePickerField() {
    var _this;
    _classCallCheck(this, DatePickerField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      selectedDate: null
    };
    _this.handleOnDateSelected = function (_ref) {
      var selected = _ref.selected,
        selectable = _ref.selectable,
        date = _ref.date;
      if (!selectable) {
        return;
      }
      _this.setState(function (state) {
        var newDate = date;
        if (state.selectedDate && state.selectedDate.getTime() === date.getTime()) {
          newDate = null;
        }
        return {
          selectedDate: newDate
        };
      });
    };
    return _this;
  }
  _createClass(DatePickerField, [{
    key: "render",
    value: function render() {
      var state = this.state;
      var selectedDate = state.selectedDate;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DatePicker, {
        selected: selectedDate,
        onDateSelected: this.handleOnDateSelected
      }), this.state.selectedDate && /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: 20,
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement("p", null, "Selected:"), /*#__PURE__*/React.createElement("p", {
        "data-test": "dateSelected"
      }, "".concat(selectedDate.toLocaleDateString()))));
    }
  }]);
  return DatePickerField;
}(React.Component);
export default DatePickerField;